var _circle, _path, _circle2, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg11235(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 34.5,
    r: 34.5,
    fill: "#4285F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 23C24.8954 23 24 23.8954 24 25V45C24 46.1046 24.8954 47 26 47H33.9385C34.6502 47 35.2934 47.3907 35.7351 47.9488C37.2023 49.8027 39.4662 51 42 51C46.4 51 50 47.4 50 43C50 39.8343 48.1342 37.0901 45.4494 35.7976C44.6289 35.4026 44 34.6301 44 33.7195V25C44 23.8954 43.1046 23 42 23H26ZM26 27C26 25.8954 26.8954 25 28 25H40C41.1046 25 42 25.8954 42 27V33C42 34.1046 41.0905 34.9745 40.0207 35.2494C36.5698 36.1361 34 39.2825 34 43C34 44.0237 33.2662 45 32.2426 45H28C26.8954 45 26 44.1046 26 43V27ZM29 29C28.4477 29 28 29.4477 28 30C28 30.5523 28.4477 31 29 31H39C39.5523 31 40 30.5523 40 30C40 29.4477 39.5523 29 39 29H29ZM29 35C28.4477 35 28 35.4477 28 36C28 36.5523 28.4477 37 29 37H33.6085C33.8636 37 34.1025 36.8784 34.2639 36.6809C34.7576 36.077 34.3621 35 33.5821 35H29ZM42 37C45.3 37 48 39.7 48 43C48 46.3 45.3 49 42 49C38.7 49 36 46.3 36 43C36 39.7 38.7 37 42 37ZM29 39C28.4477 39 28 39.4477 28 40C28 40.5523 28.4477 41 29 41H31.4683C31.8947 41 32.2591 40.6927 32.3759 40.2826C32.5528 39.6611 32.1142 39 31.468 39H29Z",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.7857,
    cy: 42.7857,
    r: 1.78571,
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9297 44.9287L45.0011 46.0001",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg11235);
export default __webpack_public_path__ + "static/media/11235.28b095a74edbc62b3cec2f8d15341fd9.svg";
export { ForwardRef as ReactComponent };